import Inputc from '../../components/input.vue';
import {ajaxUtil} from '../../common/AjaxUtil.js';
import {api, msg} from '../../common/config.js';
import {MD5Util} from '../../common/MD5Util.js';
import {validateUtil} from '../../common/ValidateUtil.js';
import {replaceUtil} from '../../common/ReplaceUtil.js';
import {CommonUtil} from '../../common/CommonUtil.js';
import {store} from '../../store/store.js';
import {StorageUtil, LocalStorageUtil} from '../../common/Auth.js';

export default {
    name: 'forget',
    components: {
        Inputc
    },
    data() {
        return {
            cardName: '',
            idCard: '',
            phone: '',
            code: '',
            step: 1,
            idPassword: '',
            idPasswordAgain: '',
            sendPassword: {
                canClick: true,
                value: "发送验证码",
                countNumber: "",
            },
            isSend: 0,//0未发送,1发送
        }
    },

    beforeRouteEnter(to, from, next) {
        next(vm => {
            // 通过 `vm` 访问组件实例,将值传入oldUrl
            StorageUtil.storeString("historyPath", from.fullPath);
        })
    },
    beforeDestroy: function () {
        StorageUtil.removeObject("historyPath");
    },
    methods: {

        //验证手机号与验证码
        toNext(n) {
            var _this = this;
            if (_this.phone.trim() == "" || _this.code.trim() == "") {
                return;
            }

            var phoneMsg = validateUtil.validate([{name: 'phone'}, {name: 'required'}], _this.phone);
            if (phoneMsg != null) {
                this.$refs.a.showError(msg.phoneError);
                return;
            } else if (_this.code.trim() == "" || _this.code.trim() == null) {
                this.$refs.b.showError(msg.codeError);
                return;
            }
            var url = api.sms.checkCode.replace('{phone}', _this.phone).replace('{code}', _this.code);
            ajaxUtil.ajaxJson(url, '', 'get', (data) => { //成功
                this.step = n;
            }, (result) => { //失败
                if (result.errorCode == 30106) {
                    CommonUtil.setInfo(result.message);
                }
            }, this);
        },


        //验证身份证号
        checkIdCard: function (n) {
            var _this = this;
            if (_this.cardName.trim() == "" || _this.idCard.trim() == "") {
                return;
            }
            if (_this.cardName.trim() == null || _this.cardName.trim().length == 0) {
                _this.$refs.c.showError(msg.emptyInput);
                return;
            }
            var message = validateUtil.validate([{name: 'idCard'}], _this.idCard);
            if (message != null) {
                _this.$refs.d.showError(msg.idCardError);
                return;
            }
            var url = api.reader.checkIdCard.replace('{idCard}', _this.idCard);
            ajaxUtil.ajaxJson(url, '', 'get', (data) => { //成功
                this.step = n;
            }, (result) => { //失败
                if (result.errorCode == 30110) {
                    CommonUtil.setInfo(msg.idCardError);
                } else if (result.errorCode == 30111) {
                    CommonUtil.setInfo(msg.idCardExist);
                }
            }, this);
        },
        //提交注册
        submitRegister: function (n) {
            var _this = this;
            if (_this.idPassword.trim() == "" || _this.idPasswordAgain.trim() == "") {
                return;
            }
            if (!_this.validatePass()) {
                return;
            }
            var url = api.reader.register;
            var submitData = {
                cardName: _this.cardName,
                idCard: _this.idCard,
                idPassword: MD5Util.hex_md5(_this.idPassword),
                phone: _this.phone,
            };
            ajaxUtil.ajaxJson(url, submitData, 'POST', (data) => { //成功
                this.step = n;
            }, (result) => { //失败
                CommonUtil.setInfo("注册失败!");
            }, this);
        },
        goback() {
            history.back()
        },

        /**
         * 验证手机号是否被绑定
         */
        validatePhone: function () {
            var _this = this;
            var error = validateUtil.validate([{name: 'phone'}, {name: 'required'}], _this.phone);
            console.log(error)
            if (error != null) {
                this.$refs.a.showError(msg.phoneError);
                return;
            }
            var url = api.reader.preUserInfo.replace('{phone}', _this.phone);
            ajaxUtil.ajaxJson(url, '', 'get', (data) => { //成功
                if (data != null) {
                    CommonUtil.setInfo(msg.phoneExist);
                } else {
                    _this.sendCode(_this.phone);
                }
            }, (result) => { //失败
            }, _this);
        },


        /**
         * 发送验证码
         */
        sendCode: function (phone) {       
            var _this = this;
            let deposit= StorageUtil.getString("deposit");           
            let postTime= new Date().getTime();      
            let regCode=postTime+deposit;           
            regCode=MD5Util.hex_md5(regCode);            
            StorageUtil.storeString("regCode",regCode);
            StorageUtil.storeString("postTime",postTime);         
            var url = api.sms.registerSend ;           
            ajaxUtil.ajaxJson(url, {'phone':phone}, 'post', (data) => { //成功
                _this.code = "";
                _this.isSend = 1;
                _this.countdown(60);
                sessionStorage.removeItem('regCode');
                sessionStorage.removeItem('postTime');                             
                CommonUtil.setInfo(msg.sendCode);
            }, (result) => { //失败
                _this.sendPassword.canClick = true;
                if (result.errorCode == 30112) {
                    CommonUtil.setInfo(msg.sendCodeError);
                }
            }, _this);
        },
        //跳转到登陆
        login: function () {
            var _this = this;
            var loginData = {
                idCard: _this.idCard,
                idPassword: MD5Util.hex_md5(_this.idPassword),
                phone: '',
            };
            var url = api.reader.login;
            ajaxUtil.ajaxLogin(url, loginData, 'POST', (data) => { //成功
                StorageUtil.storeString("token", data.token);
                StorageUtil.storeObject("user", data);
                store.token = data.token;
                store.user = data;
                if (StorageUtil.getString("repeatLoginUrl") != null) {
                    var url = StorageUtil.getString("repeatLoginUrl");
                    if (url.indexOf("bookinfo/libraryresource") != -1) {
                        StorageUtil.storeString('tolibraryResource', true)
                    }
                    StorageUtil.removeObject("repeatLoginUrl");
                    location.href = url;
                } else {
                    _this.$router.push({path: '/apply', query: {...this.$route.query}});
                }
                //this.$router.push('personal');
            }, (result) => { //失败

            }, _this);
        },
        /**
         * 检查密码格式
         */
        validatePass: function () {
            var _this = this;
            if (_this.idPassword.length < 6 && _this.idPassword.length > 0) {
                this.$refs.e.showError(msg.passCountError);
                return false;
            } else if (_this.idPassword == null || _this.idPassword.length == 0) {
                this.$refs.e.showError(msg.emptyInputPass);
                return false;
            } else if (_this.idPasswordAgain.length < 6 && _this.idPasswordAgain.length > 0) {
                this.$refs.f.showError(msg.passCountError);
                return false;
            } else if (_this.idPasswordAgain == null || _this.idPasswordAgain.length == 0) {
                this.$refs.f.showError(msg.emptyInputPass);
                return false;
            } else if (_this.idPasswordAgain != _this.idPassword) {
                this.$refs.f.showError(msg.passDisaccord);
                return false;
            }
            return true;
        },

        //倒计时
        countdown: function (initCount) {
            if (initCount < 0) {
                return
            }
            var _this = this;
            _this.sendPassword.canClick = false;
            _this.sendPassword.value = "秒后再次发送";
            var intervalId = setInterval(function () {
                initCount--;
                if (initCount <= 0) {
                    clearInterval(intervalId);
                    _this.sendPassword.countNumber = "";
                    _this.sendPassword.canClick = true;
                    var value;
                    if (_this.isSend == 1) {
                        value = "再次发送";
                    } else {
                        value = "发送验证码";
                    }
                    _this.sendPassword.value = value;
                    return;
                } else {
                    _this.sendPassword.countNumber = initCount;
                }
            }, 1000);
        },
    }
}
